import React, { useEffect, useState } from 'react';
import { Row } from 'react-flexbox-grid';
import { Input } from 'antd';
import { InputGroup, FormControl } from 'react-bootstrap';
import '../../../startproj/mergeform.css';
//import PreCommentsIcon from '../Comments/PreCommentsIcon';
import { FORM_MODE_EDIT } from '../../index';

function FormTitle({ preEForm, onChangeFormTitle, saveVisibleText, formMode, props }) {

  const [titleText, setTitleText] = useState(preEForm.formName || '');

  function handleUpdateTitle(event) {
    setTitleText(event.target.value);
  }

  return (
    <Row controlId='formTitle' style={{alignItems: 'center', marginTop: 8, marginBottom: 8}}>
      <label className='col-xs-12 col-sm-2' style={{ margin: 0}}>Title:*</label>
      <Input defaultValue={titleText}
             size="large"
             onChange={(event) => handleUpdateTitle(event)}
             onBlur={() => onChangeFormTitle(titleText)}
             maxLength='100'
             placeholder='Title'
             className='col-xs-12 col-sm-4'
             disabled={!saveVisibleText}/>
    </Row>
  );
}
export default FormTitle;
